export default "__VITE_ASSET__Ca42iit6__"